import type * as Types from '../../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PreferredPartnersForProjectsDropdownQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  query?: Types.InputMaybe<Types.Scalars['String']>;
  includeProjectId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type PreferredPartnersForProjectsDropdownQuery = { __typename?: 'Query', preferredPartners?: Array<{ __typename?: 'PreferredPartner', id: string, name: string, children: Array<{ __typename?: 'Project', id: string, title: string }> }> | null };

export type UserProjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserProjectsQuery = { __typename?: 'Query', projects?: Array<{ __typename?: 'Project', id: string, title: string }> | null };


export const PreferredPartnersForProjectsDropdownDocument = gql`
    query PreferredPartnersForProjectsDropdown($offset: Int, $limit: Int, $query: String, $includeProjectId: ID) {
  preferredPartners(
    offset: $offset
    limit: $limit
    query: $query
    includeProjectId: $includeProjectId
  ) {
    id
    name
    children: project(query: $query) {
      id
      title
    }
  }
}
    `;

/**
 * __usePreferredPartnersForProjectsDropdownQuery__
 *
 * To run a query within a React component, call `usePreferredPartnersForProjectsDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreferredPartnersForProjectsDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreferredPartnersForProjectsDropdownQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      query: // value for 'query'
 *      includeProjectId: // value for 'includeProjectId'
 *   },
 * });
 */
export function usePreferredPartnersForProjectsDropdownQuery(baseOptions?: Apollo.QueryHookOptions<PreferredPartnersForProjectsDropdownQuery, PreferredPartnersForProjectsDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreferredPartnersForProjectsDropdownQuery, PreferredPartnersForProjectsDropdownQueryVariables>(PreferredPartnersForProjectsDropdownDocument, options);
      }
export function usePreferredPartnersForProjectsDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreferredPartnersForProjectsDropdownQuery, PreferredPartnersForProjectsDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreferredPartnersForProjectsDropdownQuery, PreferredPartnersForProjectsDropdownQueryVariables>(PreferredPartnersForProjectsDropdownDocument, options);
        }
export type PreferredPartnersForProjectsDropdownQueryHookResult = ReturnType<typeof usePreferredPartnersForProjectsDropdownQuery>;
export type PreferredPartnersForProjectsDropdownLazyQueryHookResult = ReturnType<typeof usePreferredPartnersForProjectsDropdownLazyQuery>;
export type PreferredPartnersForProjectsDropdownQueryResult = Apollo.QueryResult<PreferredPartnersForProjectsDropdownQuery, PreferredPartnersForProjectsDropdownQueryVariables>;
export const UserProjectsDocument = gql`
    query UserProjects {
  projects(onlyUpdatable: true, skipEventRooms: true) {
    id
    title
  }
}
    `;

/**
 * __useUserProjectsQuery__
 *
 * To run a query within a React component, call `useUserProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserProjectsQuery(baseOptions?: Apollo.QueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
      }
export function useUserProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProjectsQuery, UserProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProjectsQuery, UserProjectsQueryVariables>(UserProjectsDocument, options);
        }
export type UserProjectsQueryHookResult = ReturnType<typeof useUserProjectsQuery>;
export type UserProjectsLazyQueryHookResult = ReturnType<typeof useUserProjectsLazyQuery>;
export type UserProjectsQueryResult = Apollo.QueryResult<UserProjectsQuery, UserProjectsQueryVariables>;